import { createContext, useContext, useEffect, useMemo, useState } from "react";

const BetSlipContext = createContext(null);
export const useBetSlip = () => useContext(BetSlipContext);

const load = (k, fb) => {
  try {
    const v = JSON.parse(localStorage.getItem(k));
    return v ?? fb;
  } catch {
    return fb;
  }
};

export function BetSlipProvider({ children }) {
  const [legs, setLegs] = useState(() => load("pl_slip", []));
  const [stake, setStake] = useState(() => Number(localStorage.getItem("pl_stake")) || 10);

  useEffect(() => {
    localStorage.setItem("pl_slip", JSON.stringify(legs));
  }, [legs]);
  useEffect(() => {
    localStorage.setItem("pl_stake", String(stake));
  }, [stake]);

  const toggleLeg = (leg) =>
    setLegs((prev) => (prev.some((l) => l.id === leg.id) ? prev.filter((l) => l.id !== leg.id) : [...prev, leg]));
  const removeLeg = (id) => setLegs((prev) => prev.filter((l) => l.id !== id));
  const clear = () => setLegs([]);
  const has = (id) => legs.some((l) => l.id === id);

  const summary = useMemo(() => {
    if (legs.length === 0) return null;
    const combinedOdds = legs.reduce((a, l) => a * (l.odd || 1), 1);
    const combinedProb = legs.reduce((a, l) => a * (l.prob || 1 / (l.odd || 2)), 1);
    return {
      combinedOdds,
      combinedProb,
      fairOdds: combinedProb > 0 ? 1 / combinedProb : 0,
      potentialReturn: stake * combinedOdds,
      profit: stake * combinedOdds - stake,
      valuePct: Math.round((combinedProb * combinedOdds - 1) * 100),
    };
  }, [legs, stake]);

  return (
    <BetSlipContext.Provider value={{ legs, toggleLeg, removeLeg, clear, has, stake, setStake, summary }}>
      {children}
    </BetSlipContext.Provider>
  );
}
